@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.package {
  width: 100%;
  border-radius: 5px;
  border: 1px solid @multi-package-modal--item--border-color;
  box-shadow: 1px 1px 4px @multi-package-modal--item--box-shadow-color;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid @multi-package-modal--item--border-color;
  background-color: @multi-package-modal--item-header--background-color;
  padding: 10px 15px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.title {
  font-size: 18px;
}

.links {
  display: flex;
  flex-direction: row;
}

.body {
  background-color: @multi-package-modal--item-body--background-color;
  padding: 15px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;

  > div {
    margin-bottom: 10px;
    display: flex;
  }

  > div:last-child {
    margin-bottom: 0;
  }
}

.spacer-bar {
  width: 1px;
  height: 100%;
  background-color: @multi-package-modal--item-space-bar--background-color;
  margin: auto 15px;
}

.weight-grams {
  width: 200px;
}

.weight-ounces {
  width: 250px;
}

.scale {
  min-width: 78px;
}

.row {
  display: flex;
}

.content {
  flex: 1;
  max-width: 325px;
}

.row-label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 125px;
  padding-right: 10px;
}

.read-only {
  .row-label {
    justify-content: start;
    min-width: 35%;
  }

  .body {
    line-height: 1.5;
  }
}

.package-description {
  padding-right: @space-32;

  > label {
    align-items: start;
    line-height: 1.2;
    text-align: right;
  }

  // make the Input take up all the horizontal space
  > div {
    flex: 1;
  }
}
